import {
  PriceSettingsPaymentMethod,
  type FormattedPriceSettings,
} from '@setplex/tria-api'

export const getPriceSettingsExternalPaymentData = (
  priceSettings: FormattedPriceSettings[] | null | undefined,
  itemExternalId?: string | null
) => {
  const priceSettingsPerItem = priceSettings?.find(
    (setting) => setting.paymentMethod === PriceSettingsPaymentMethod.PerItem
  )

  if (priceSettingsPerItem) {
    return {
      externalId: itemExternalId,
      priceType: priceSettingsPerItem?.type,
    }
  }

  const priceSettingsWithBundle = priceSettings?.find(
    (setting) =>
      setting.bundle &&
      setting.paymentMethod === PriceSettingsPaymentMethod.PerSet
  )

  return {
    externalId: priceSettingsWithBundle?.bundle?.externalId,
    priceType: priceSettingsWithBundle?.type,
  }
}
